import KoioteValueLabelWriteOne from './KoioteValueLabelWriteOne.vue'
import KoioteValueLabelWriteOneProperties from './KoioteValueLabelWriteOneProperties.vue'
import KoioteValueLabelWriteOneProperty from './default.json'

export default {
    install(Vue, options) {
        Vue.component(KoioteValueLabelWriteOne.name, KoioteValueLabelWriteOne)
        Vue.component(KoioteValueLabelWriteOneProperties.name, KoioteValueLabelWriteOneProperties)
        Vue.prototype.$ValueLabelWriteOneProperties = KoioteValueLabelWriteOneProperty

        Vue.mixin({
            mounted() {
                // console.log('Montadito!');
            }
        });
    }
};

